import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { CognitoUtil } from 'src/app/shared/utils/cognito.service';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/shared/utils/common.service';
@Component({
  selector: 'app-dashboard-user-management',
  templateUrl: './dashboard-user-management.component.html',
  styleUrls: ['./dashboard-user-management.component.scss'],
})
export class DashboardUserManagementComponent implements OnInit, OnDestroy {
  subscription: Subscription | undefined;
  sharedData: any;
  readonly LANG_CONST = LANG_CONST;

  constructor(
    public cognitoUtil: CognitoUtil,
    private stateManagementService: StateManagementService,
    public sharedDataService: SharedDataService,
    private router: Router,
    private commonService: CommonService,
  ) {}

  ngOnInit(): void {
    this.stateManagementService.updateShowHeader(true);

    this.subscription = this.sharedDataService.currentData.subscribe(
      (sharedData: any) => {
        this.sharedData = sharedData;
      }
    );
  }
  navigateBack() {
    this.router.navigate(['/dashboard']);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
      this.commonService.setUserGroupId('');
  }
}
